import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./installs.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { WireI18n } from '~/modules/stores/i18nStore';
import { legacyStore } from '~/modules/stores/legacyStore';
class Installs extends LightningElement {
  constructor() {
    super();
    this.
    // @ts-expect-error * Automated Type Error Fix
    i18n = void 0;
    this.store = {
      currentInstalls: '',
      installs: [],
      isError: false,
      isLoading: false,
      isEmpty: false
    };
    this.fetchInstalls();
  }
  fetchInstalls() {
    legacyStore.fetchInstalls();
  }

  // @ts-expect-error * Automated Type Error Fix
  // @ts-expect-error * Automated Type Error Fix
  setInstalls(data, error) {
    if (data) {
      // @ts-expect-error * Automated Type Error Fix
      this.store = data;
    } else if (error) {
      this.store.isError = true; // in this case is not connected to store
    }
  }
  get loopFourTimes() {
    return ['loading1', 'loading2', 'loading3', 'loading4'];
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Installs, {
  track: {
    store: 1
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    setInstalls: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: legacyStore,
          selector: state => state.installs
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Installs, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;